import { Box, VStack, HStack, Skeleton, SkeletonCircle, Text } from '@chakra-ui/react';

const PeerSupportContactReportSkeleton = () => {
  return (
    <Box w="full">
      <VStack align="center" spacing="30px">
        {/* Charts row */}
        <HStack spacing="40px" w="full" justifyContent={'space-between'} alignItems={'start'}>
          {/* Contacts bar chart */}
          <VStack align="start" w="full" spacing="20px" flex={1}>
            <Skeleton height="18px" width="100px" borderRadius={'4px'} />
            <HStack align="end" spacing="6">
              <Skeleton height="60px" width="32px" borderRadius={'10px'} />
              <Skeleton height="158px" width="32px" borderRadius={'10px'} />
              <Skeleton height="80px" width="32px" borderRadius={'10px'} />
              <Skeleton height="110px" width="32px" borderRadius={'10px'} />
              <Skeleton height="50px" width="32px" borderRadius={'10px'} />
            </HStack>
          </VStack>

          {/* Subjects donut */}
          <VStack alignItems="start" spacing="20px" flex={1}>
            <VStack align={'start'} spacing={'20px'}>
              <Skeleton height="18px" width="80px" borderRadius={'4px'} />
            </VStack>
            <HStack spacing={'20px'}>
              <SkeletonCircle size="160px" />
              <VStack spacing="8px">
                {Array.from({ length: 7 }).map((_, i) => (
                  <HStack key={i} spacing="3">
                    <SkeletonCircle height={'12px'} width={'12px'} />
                    <Skeleton height="14px" width="100px" borderRadius={'4px'} />
                  </HStack>
                ))}
              </VStack>
            </HStack>
          </VStack>

          {/* Outcomes donut */}
          <VStack alignItems="start" spacing="20px" flex={1}>
            <VStack align={'start'} spacing={'20px'}>
              <Skeleton height="18px" width="80px" borderRadius={'4px'} />
            </VStack>
            <HStack spacing={'20px'}>
              <SkeletonCircle size="160px" />
              <VStack spacing="8px">
                {Array.from({ length: 4 }).map((_, i) => (
                  <HStack key={i} spacing="3">
                    <SkeletonCircle height={'12px'} width={'12px'} />
                    <Skeleton height="14px" width="100px" borderRadius={'4px'} />
                  </HStack>
                ))}
              </VStack>
            </HStack>
          </VStack>
        </HStack>

        {/* Divider / Subtitle */}
        <Text variant={'loraSmallTitle'} fontWeight={500} marginTop={'60px'} marginBottom={'40px'}>
          Peer Support Timeline
        </Text>

        {/* Table */}
        <VStack align="start" w="full" spacing="3" mt="2" px={'200px'}>
          {/* Table header */}
          <HStack justify="space-between" w="full">
            <Skeleton height="3" width="120px" />
            <Skeleton height="3" width="200px" />
            <Skeleton height="3" width="150px" />
          </HStack>

          {/* Table rows */}
          {Array.from({ length: 3 }).map((_, i) => (
            <HStack key={i} justify="space-between" w="full" mt="2">
              <Skeleton height="3" width="100px" />
              <Skeleton height="3" width="60%" />
              <Skeleton height="3" width="150px" />
            </HStack>
          ))}
        </VStack>

        {/* View more */}
        <Skeleton height="3" width="100px" alignSelf="center" mt="4" />
      </VStack>
    </Box>
  );
};

export default PeerSupportContactReportSkeleton;
